import { useMediaQuery } from 'react-responsive'

export type MediaComponentProps = {
    children: React.ReactNode
}

export enum Breakpoint {
    XS = 0,
    SM = 576,
    MD = 768,
    LG = 992,
    XL = 1200,
    XXL = 1350,
    XXXL = 1700,
    XXXXL = 2000,
    XXXXXL = 2400,
    INFINITE = 1000000
}

export const useThresholdMediaQuery = (min: Breakpoint, max: Breakpoint) => useMediaQuery({ minWidth: min, maxWidth: max-1 })

export const useDesktopMediaQuery  = ()=> useMediaQuery({ minWidth: 1200 })
export const useTabletMediaQuery   = ()=> useMediaQuery({ minWidth: 768, maxWidth: 1199 })
export const useMobileMediaQuery   = ()=> useMediaQuery({ maxWidth: 767 })

export const Desktop = ({ children }: MediaComponentProps):JSX.Element => {
    const isDesktop = useDesktopMediaQuery()
    return isDesktop ? <>{children}</> : <></>
}
export const Tablet = ({ children }: MediaComponentProps):JSX.Element => {
    const isTablet = useTabletMediaQuery()
    return isTablet ? <>{children}</> : <></>
}
export const Mobile = ({ children }: MediaComponentProps):JSX.Element => {
    const isMobile = useMobileMediaQuery()
    return isMobile ? <>{children}</> : <></>
}

export const DesktopOrTablet = ({ children }: MediaComponentProps):JSX.Element => {
    const isDesktop = useDesktopMediaQuery()
    const isTablet = useTabletMediaQuery()
    return (isDesktop || isTablet) ? <>{children}</> : <></>
}

export const TabletOrMobile = ({ children }: MediaComponentProps):JSX.Element => {
    const isMobile = useMobileMediaQuery()
    const isTablet = useTabletMediaQuery()
    return (isMobile || isTablet) ? <>{children}</> : <></>
}

export const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0